import { render, staticRenderFns } from "./collectionInfo.vue?vue&type=template&id=0d9dbb7f"
import script from "./collectionInfo.vue?vue&type=script&lang=js"
export * from "./collectionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports